import { render } from "./CatTable.vue?vue&type=template&id=45281e2a&scoped=true"
import script from "./CatTable.vue?vue&type=script&lang=js"
export * from "./CatTable.vue?vue&type=script&lang=js"

import "./CatTable.vue?vue&type=style&index=0&id=45281e2a&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45281e2a"]])

export default __exports__